<template>
	<div class="sk-widget sk-widget-delivery-slot">
		<div>
			<div class="sk-widget-delivery-cart-date">
				<b>{{ formattedDay }}</b>
				{{ formattedDate }}
			</div>
			<div class="sk-widget-delivery-cart-summary">
				<span>
					<i class="sk-icon-utensil-fork-solid"></i>
					{{ deliverySlot.menuName }}
				</span>
				<span>
					<i class="sk-icon-shopping-cart-solid"></i>
					{{ deliverySlot.itemQuantity }}
				</span>
			</div>
		</div>
		<div v-if="!readonly">
			<SkDropdownSelect
				v-model="timeSlot"
				:options="timeSlots"
				:classes="'sk-select-alternate'"
				ref="dropdown"
			/>
		</div>
		<div v-else class="delivery-slot-readonly">
			{{ timeSlot.text }}
		</div>
	</div>
</template>

<style scoped>
.sk-widget-delivery-slot {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.sk-widget-delivery-slot > div {
	width: auto;
}

.sk-widget-delivery-cart-date {
	margin-bottom: 5px;
}

.sk-widget-delivery-cart-date,
.sk-widget-delivery-cart-date b {
	font-size: 14px;
	color: var(--gR-base-80);
}

.sk-widget-delivery-cart-date b {
	margin-right: 10px;
}

.sk-widget-delivery-cart-summary span {
	color: var(--sk-grey3);
	font-size: 10px;
}

.sk-widget-delivery-cart-summary span + span {
	margin-left: 30px;
}

.sk-widget-delivery-cart-summary i {
	color: var(--sk-grey2);
	margin-right: 10px;
}

.delivery-slot-readonly {
	font-size: 12px;
	color: var(--gR-base-80);
	font-weight: 600;
}
</style>

<script>
import momentUtils from "@/moment-utils"
import moment from "moment"
import SkDropdownSelect from "@/components/common/SkDropdownSelect.vue"

export default {
	name: "ResidentialDeliverySlot",
	components: {
		SkDropdownSelect
	},
	props: {
		deliverySlot: Object,
		readonly: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		timeSlots() {
			if (this.readonly || !this.deliverySlot) {
				return []
			}
			const todaysDate = momentUtils.todaysDate()
			const date = moment(this.deliverySlot.deliveryDate, "YYYY-MM-DD")
			const isToday = momentUtils.isSameDay(date, todaysDate)
			const timeSlots = momentUtils.generateTimeSlots(
				this.deliverySlot.dailySchedule,
				this.deliverySlot.menuInStock,
				isToday
			)
			return timeSlots
		},
		timeSlot: {
			get: function () {
				const deliveryTime = this.deliverySlot.deliveryTime
				const numTime =
					!deliveryTime || deliveryTime == -1
						? -1
						: momentUtils.numericalTime(deliveryTime)
				let text = ""
				if (this.readonly) {
					text =
						numTime == -1
							? "ASAP"
							: moment(deliveryTime, "HH:mm").format("h:mm A")
				} else if (this.timeSlots.length > 0) {
					text =
						numTime == -1
							? "ASAP"
							: this.timeSlots.find(
									(option) => option.id == numTime
							  ).text
				}
				return {
					id: numTime,
					text: text
				}
			},
			set: function (timeSlot) {
				if (timeSlot.time) {
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Residential Delivery Slot Selected",
						data: {
							slot: timeSlot.time,
							date: this.deliverySlot.deliveryDate
						}
					})
					const payload = {
						menuId: this.deliverySlot.menuId,
						deliveryTime: timeSlot.time,
						date: this.deliverySlot.deliveryDate
					}
					this.$store.dispatch("setResidentialDeliveryTime", payload)
				}
			}
		},
		formattedDay() {
			if (!this.deliverySlot) {
				return ""
			}
			const todaysDate = momentUtils.todaysDate()
			const date = moment(this.deliverySlot.deliveryDate, "YYYY-MM-DD")
			const isToday = momentUtils.isSameDay(date, todaysDate)
			return isToday ? "Today" : date.format("dddd")
		},
		formattedDate() {
			if (!this.deliverySlot) {
				return ""
			}
			const date = moment(this.deliverySlot.deliveryDate, "YYYY-MM-DD")
			return moment(date, "YYYY-MM-DD").format("MMMM Do")
		}
	}
}
</script>